import React, { FC } from 'react';
import Icon from '@ant-design/icons/lib';

const LogoSvg = () => (
  <svg viewBox="0 0 156 96" width="1.95rem" height="1.3rem">
    <g id="HigoDoctor/Splash" transform="translate(-649.000000, -464.000000)">
      <path
        d="M661,500 L685,500 L685,476 C685,469.372583 690.372583,464 697,464 C703.627417,464 709,469.372583 709,476 L709,500 L727,500 C733.627417,500 739,505.372583 739,512 C739,518.627417 733.627417,524 727,524 L709,524 L709,548 C709,554.627417 703.627417,560 697,560 C690.372583,560 685,554.627417 685,548 L685,524 L661,524 C654.372583,524 649,518.627417 649,512 C649,505.372583 654.372583,500 661,500 Z M757,464 C763.627417,464 769,469.372583 769,476 L769,500 L793,500 C799.627417,500 805,505.372583 805,512 C805,518.627417 799.627417,524 793,524 L769,524 L769,548 C769,554.627417 763.627417,560 757,560 C750.372583,560 745,554.627417 745,548 L745,476 C745,469.372583 750.372583,464 757,464 Z"
        id="H03"
        fill="#39c0fe"
      />
    </g>
  </svg>
);

const LogoBlackSvg = () => (
  <svg viewBox="0 0 156 96" width="1.5rem" height="1rem">
    <g id="HigoDoctor/Splash" transform="translate(-649.000000, -464.000000)">
      <path
        d="M661,500 L685,500 L685,476 C685,469.372583 690.372583,464 697,464 C703.627417,464 709,469.372583 709,476 L709,500 L727,500 C733.627417,500 739,505.372583 739,512 C739,518.627417 733.627417,524 727,524 L709,524 L709,548 C709,554.627417 703.627417,560 697,560 C690.372583,560 685,554.627417 685,548 L685,524 L661,524 C654.372583,524 649,518.627417 649,512 C649,505.372583 654.372583,500 661,500 Z M757,464 C763.627417,464 769,469.372583 769,476 L769,500 L793,500 C799.627417,500 805,505.372583 805,512 C805,518.627417 799.627417,524 793,524 L769,524 L769,548 C769,554.627417 763.627417,560 757,560 C750.372583,560 745,554.627417 745,548 L745,476 C745,469.372583 750.372583,464 757,464 Z"
        id="H03"
        fill="#000000"
      />
    </g>
  </svg>
);

export const LogoIcon: FC = (props) => <Icon component={LogoSvg} {...props} />;
export const LogoBlackIcon: FC = (props) => (
  <Icon component={LogoBlackSvg} {...props} />
);
